/* eslint-disable max-len */
import { fromJS, List } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import PricingModel from 'models/PricingBusinessViability/PricingModel';
import ProductPricingModel from 'models/PricingBusinessViability/ProductPricingModel';
import { byId } from 'store/utils/sortFunctions';
import { PRICING_MODEL_INITIAL_OFFSET } from 'styles/toolColors';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {
      byId: {},
      byProduct: {},
    },
    errorMessage: '',
    updatePending: false,
  }),
});

export default function reducer(state = initialState, action) {
  const productId = action.payload && String(action.payload.product);
  switch (action.type) {
    case types.PRICING_MODELS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byProduct: state.get('data').get('byProduct'),
            byId: action.payload.results.reduce(
              (pricingModelsById, pricingModel, index) =>
                pricingModelsById.set(
                  pricingModel.id.toString(),
                  new PricingModel({
                    colorIndex: index + PRICING_MODEL_INITIAL_OFFSET,
                    ...pricingModel,
                  })
                ),
              state.get('data').get('byId')
            ),
          },
        })
      );
    case types.PRODUCT_PRICING_MODELS_LIST_SUCCEEDED:
      return state.merge(
        reduxHelper.applyRequestInfo({
          data: {
            byId: state.get('data').get('byId'),
            byProduct: state
              .get('data')
              .get('byProduct')
              .set(
                productId,
                action.payload.results.reduce(
                  (list, pricingModel) =>
                    list
                      .set(pricingModel.id, new ProductPricingModel(pricingModel))
                      // Redundant filtering, but just in case.
                      .filter(model => Boolean(model) && String(model.product) === productId),
                  new List()
                )
              ),
          },
        })
      );
    case types.PRODUCT_PRICING_MODEL_FETCH_SUCCEEDED:
    case types.PRODUCT_PRICING_MODEL_CREATE_SUCCEEDED:
    case types.PRODUCT_PRICING_MODEL_UPDATE_SUCCEEDED:
      return (() => {
        const pricingModelsByIdByProduct = state
          .get('data')
          .get('byProduct')
          .get(productId, new List())
          .filter(pricingModel => pricingModel.id !== action.payload.id)
          .push(new ProductPricingModel(action.payload))
          .sort(byId);
        return state.merge(
          reduxHelper.applyRequestInfo({
            updatePending: false,
            data: {
              byId: state.get('data').get('byId'),
              byProduct: state
                .get('data')
                .get('byProduct')
                .set(productId, pricingModelsByIdByProduct),
            },
          })
        );
      })();
    case types.PRODUCT_PRICING_MODEL_FETCH:
    case types.PRODUCT_PRICING_MODEL_CREATE:
    case types.PRODUCT_PRICING_MODEL_UPDATE:
      return state.merge(
        reduxHelper.applyRequestInfo({
          updatePending: true,
        })
      );
    case types.PRODUCT_PRICING_MODEL_DELETE_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: {
            byId: state.get('data').get('byId').delete(String(action.payload.id)),
            byProduct: state
              .get('data')
              .get('byProduct')
              .set(
                String(action.payload.product),
                state
                  .get('data')
                  .get('byProduct')
                  .get(productId, [])
                  .filter(pricingModel => pricingModel.id !== action.payload.id)
                  .sort(byId)
              ),
          },
        })
      );
    case types.PRODUCT_PRICING_MODEL_UPDATE_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          updatePending: false,
          errorMessage: action.payload,
        })
      );
    case types.PRODUCT_PRICING_MODEL_CLEAR_ERROR:
      return state.merge(reduxHelper.applyReceiveInfo());
    case types.PRODUCT_PRICING_MODEL_FETCH_FAILED:
    case types.PRODUCT_PRICING_MODELS_LIST_FAILED:
    case types.PRICING_MODELS_LIST_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
